const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/support/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import type { SupportTicketListParams } from "@/types/api/support";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/support/")({
  beforeLoad: args => requirePermission(Permissions.Support.ViewTickets, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type View = {
  key: string;
  label: string;
  params: SupportTicketListParams;
  count?: (s: ReturnType<typeof useSupportSummary>["data"]) => number | undefined;
};